export const ORDERS_FLEX_WIDTH = 4;
export const RECEPTIONS_FLEX_WIDTH = 5;
